import { Div, Image, Span } from "@tblabs/truffle";


export class LoaderSpinner extends Div
{
    constructor(label: string)
    {
        super();
        this.TextAlignCenter().MarginTop(32);

        this.Append(
            new Image("spinner.gif").Height(32),
            new Span(label).MarginLeft(8)
        );
    }
}
